import React from 'react';
import { useLocalization } from '../../store/utils/useLocalization';
import { formatTranslation } from '../../utils/stringFunctions';
import { StyleProp, Text, TextStyle } from 'react-native';

interface Props {
  distance: number;
  style?: StyleProp<TextStyle>;
}

/**
 * Given a decimal distance in miles, returns a human-readable text
 * representation. Miles are rounded to one decimal place. The label is
 * localized and appropriately pluralized. E.g. a distance prop of 0.42
 * would return '0.4 miles away' in English.
 */
function PantryDistance(props: Props) {
  const { translation } = useLocalization();

  let displayDistance = '';
  const roundedDistance = Math.round(props.distance * 10) / 10;
  if (roundedDistance === 1) {
    // TODO: Replace with handlebars style template (https://github.com/PlentifulApp/plentiful/issues/1634)
    displayDistance = formatTranslation(translation.miles_away_singular, [roundedDistance.toString()]);
  } else {
    displayDistance = formatTranslation(translation.miles_away_plural, [roundedDistance.toString()]);
  }

  return (
    <Text style={props.style} testID="pantry-distance">
      {displayDistance}
    </Text>
  );
}

export default PantryDistance;
